export default __webpack_public_path__ + "static/media/visual3.8fdff769.png";